const COLORS = {
    green: '#40B92D'
}

export default COLORS;